<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="279" height="280" viewBox="0 0 279 280">
	  <g id="Group_12374" data-name="Group 12374" transform="translate(-661 -923)">
	    <path id="Path_2536" class="st0" data-name="Path 2536" d="M139.5,0C216.544,0,279,62.68,279,140S216.544,280,139.5,280,0,217.32,0,140,62.456,0,139.5,0Z" transform="translate(661 923)"/>
	    <g id="Group_12308" data-name="Group 12308" transform="translate(-3448 4961.003)">
			<path id="Subtraction_2" class="st1" data-name="Subtraction 2" d="M.088,36.056h0C.029,35.456,0,34.846,0,34.241V19A19,19,0,0,1,19,0h84.767a15,15,0,0,1,15,15v9.572H13A12.99,12.99,0,0,0,.088,36.056Z" transform="translate(4173 -3961.003)"/>
			<path id="Path_2528" class="st1" data-name="Path 2528" d="M49.964,47.506H22.115A22.1,22.1,0,0,1,0,25.391V22.115A22.1,22.1,0,0,1,22.115,0H49.964a4.92,4.92,0,0,1,4.915,4.915V42.592A4.92,4.92,0,0,1,49.964,47.506ZM21.705,16.381a7.781,7.781,0,1,0,7.782,7.782A7.79,7.79,0,0,0,21.705,16.381Z" transform="translate(4262.28 -3905.903)"/>
			<path id="Path_2527" class="st1" data-name="Path 2527" d="M126.139,95.014H14.743A14.744,14.744,0,0,1,0,80.27V10.648A10.649,10.649,0,0,1,10.648,0H126.139a10.649,10.649,0,0,1,10.648,10.648v7.372H104.023A22.1,22.1,0,0,0,81.908,40.135V54.878a22.1,22.1,0,0,0,22.115,22.115h32.764v7.372a10.649,10.649,0,0,1-10.648,10.648Z" transform="translate(4173 -3929.656)"/>
	    </g>
	  </g>
	</svg>
</template>
<script>
export default {
	name: 'counterSvg',
}
</script>

<style scoped>
/* eslint-disable */
.st0 {
	fill: var(--iconsColor1); 
}
.st1 {
	fill: var(--iconsColor2); 
}
svg {
	width: 100%;
	height: 100%;
}
</style>